export const formatDateDDMMYYYY = (dateString) => {
  if (!dateString) return "";

  let dateObj;
  if (dateString instanceof Date) {
    dateObj = dateString;
  } else {
    const dateStr = dateString.toString().split('.')[0];
    dateObj = new Date(dateStr);
  }

  if (isNaN(dateObj)) return dateString;

  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const year = dateObj.getFullYear();

  return `${day}/${month}/${year}`;
};
